import { Form } from "react-bootstrap"

// when edit is used, the value passed to the reset form of react hook form will be populated in the field.

export default function KDSelect({ html_id, objectKey,valueLabelList=[], onChangeHandler=()=>{}, html_placeholder, className, fieldReadOnly, __register=()=>{return [{test:'test'}]}, __error=[{test:'test'}] }) { // __ ensures that if this component is copied in the standard react hook form template, it will not conflict with the variable/method names of that form
    return (
        <div className={'d-flex flex-column align-items-start justify-content-center'}>
            <label
                htmlFor={objectKey}
                className="form-label pe-2"
                style={{
                    width: 'fit-content',
                    fontSize: '.8em',
                    whiteSpace: 'nowrap',
                }}
            >
                {html_placeholder}
            </label>
            <Form.Select disabled={fieldReadOnly} onChange={(e)=>{
                onChangeHandler(e);
            }} id={objectKey} name={objectKey} aria-label="Default select" {...__register(objectKey,{required:true})}>
                {valueLabelList?.length>0 && <option defaultChecked value={valueLabelList[0].value}>{valueLabelList[0].label}</option>}
                {valueLabelList?.length>1 && valueLabelList?.filter((item,index)=>index>0)?.map((item,index)=>{
                    return <option key={index} value={item.value}>{item.label}</option>
                })}
            </Form.Select>
            {__error[objectKey] && <span>This field is required</span>}
        </div>
    );
};


// example
{/* <KDSelect  __error={__error} __register={__register} fieldReadOnly={__formReadOnly} objectKey="duration" html_placeholder="Duration (Years)"
valueLabelList={[{label:'One',value:'1'},{label:'Two',value:"2"},{label:'Three',value:"3"}]}
/> */}